import { client } from '@chegg/checkout-sdk';
import { ErrorType } from '../constants/Errors';
export var authorize = function authorize(params) {
  return client.authorize(params);
};
export var getAddress = function getAddress(params) {
  return client.addressValidationApi.searchCities(params).then(function (response) {
    return transformData(response);
  });
};

// TODO refine any type
export var transformData = function transformData(response) {
  var _response$data$data, _response$data$data2, _response$data$data$s, _response$data$data3, _response$data$errors;
  if (!response.data) return {
    data: {
      success: false,
      error: response.error
    },
    errors: response.error
  };
  return {
    data: {
      success: !!((_response$data$data = response.data.data) !== null && _response$data$data !== void 0 && (_response$data$data = _response$data$data.searchCities) !== null && _response$data$data !== void 0 && _response$data$data.length),
      city_states: (_response$data$data2 = response.data.data) === null || _response$data$data2 === void 0 ? void 0 : _response$data$data2.searchCities,
      matches: (_response$data$data$s = (_response$data$data3 = response.data.data) === null || _response$data$data3 === void 0 || (_response$data$data3 = _response$data$data3.searchCities) === null || _response$data$data3 === void 0 ? void 0 : _response$data$data3.length) !== null && _response$data$data$s !== void 0 ? _response$data$data$s : 0,
      // TODO refine any type
      error: (_response$data$errors = response.data.errors) === null || _response$data$errors === void 0 || (_response$data$errors = _response$data$errors.map(function (error) {
        return {
          message: error.message,
          code: error.extensions.code,
          type: ErrorType.SERVER
        };
      })) === null || _response$data$errors === void 0 ? void 0 : _response$data$errors[0]
    },
    errors: response.errors
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/api/index.js
// module id = 888
// module chunks = 11